import React, { useEffect, useState } from "react";
import { playOneAnimation, setAnimationFrame } from "src/services/animations";
import { useStore } from "src/store";
import {
  componentAnimationReadyToPlay,
  componentAnimationReadyToStop,
} from "src/utils/helper";
import { Title, Text, Spacer } from "../dynamic.components";
import play from "src/assets/svg/play.svg";

export const GasManagementBio: React.FC = (): JSX.Element => {
  const [state, setState] = useState({
    pinch: false,
    filter: false,
  });

  const {
    sidebarStatus,
    animationStopped,
    animationIsPlaying,
    setAnimationStopped,
    activeSubLink: { text, extras, staticFrameWithHotspot },
  } = useStore();

  useEffect(() => {
    if (componentAnimationReadyToPlay("2-6")) {
      staticFrameWithHotspot && setAnimationFrame(staticFrameWithHotspot[0]);
      setState({ pinch: true, filter: false });
    }
    if (componentAnimationReadyToStop("2-6")) {
      setAnimationStopped(true);
    }
  }, [sidebarStatus, animationStopped]);

  return (
    <>
      <Title title={text} />
      <div className="c-sidebar__body">
        <Text text="The X-platform will automatically switch to a new filter using the pinch valves when the pressure in the head space reaches the threshold." />

        <button
          style={{ width: "330px" }}
          onClick={() => {
            setState({ pinch: false, filter: true });
            playOneAnimation(
              extras?.annotations?.[0],
              extras?.animationSequences?.[0],
              true,
              true
            );
          }}
          className={`button button--secondary button--xlarge button--fixwidth ${
            animationIsPlaying && state.filter
              ? "button--disabled"
              : state.filter && "button--hover"
          }`}
          disabled={animationIsPlaying}
        >
          <span style={{ margin: "auto" }}>Exhaust filter and heater</span>
          <img
            className={`play-icon ${
              animationIsPlaying && state.filter ? "play-icon-animate" : ""
            }`}
            src={play}
            alt="play animation"
          />
        </button>
        <Spacer />
        <button
          style={{ width: "330px" }}
          onClick={() => {
            setState({ pinch: true, filter: false });
            staticFrameWithHotspot &&
              setAnimationFrame(staticFrameWithHotspot[0]);
          }}
          className={`button button--secondary button--xlarge button--fixwidth 
            ${state.pinch && "button--hover"}`}
          disabled={animationIsPlaying}
        >
          Pinch valve
        </button>
        <Spacer x={2} />
      </div>
    </>
  );
};
